import { captureException } from '@sentry/react';
import { useCallback } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { authenticatedUserState, sessionExpiredState } from '../state/AuthState';

export function useToken() {
  const user = useAtomValue(authenticatedUserState);
  const setSessionExpired = useSetAtom(sessionExpiredState);

  return useCallback(async (): Promise<string> => {
    try {
      return user?.accessToken ?? '';
    } catch (err) {
      captureException(err);
      setSessionExpired(true);

      return '';
    }
  }, [setSessionExpired, user?.accessToken]);
}
